import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemDetailsStore } from './item-details.store';

@Injectable({
  providedIn: 'root'
})
export class ReadonlyItemDetailsStore {
  constructor(private itemDetailsStore: ItemDetailsStore) {}

  private readonly _recommendedItemIdStack$ = new BehaviorSubject<string[]>([]);
  readonly hasParentSheet$: Observable<boolean> =
    this._recommendedItemIdStack$.pipe(map((stack) => stack.length > 0));

  pushToStack(id: string) {
    const stack = this._recommendedItemIdStack$.getValue();
    stack.push(id);
    this._recommendedItemIdStack$.next(stack);
  }

  popStack(): string | undefined {
    const stack = this._recommendedItemIdStack$.getValue();
    const top = stack.pop();
    this._recommendedItemIdStack$.next(stack);
    return top;
  }

  clearStack() {
    this._recommendedItemIdStack$.next([]);
    this.itemDetailsStore.clearSelectedItem();
  }
}
